import type { PatientAddressFormData } from '@/schemas/patientAddressSchema';

export function buildPatientAddressFormInitialValues(
  defaultValues?: Partial<PatientAddressFormData>
): PatientAddressFormData {
  return {
    postal_code1: '',
    postal_code2: '',
    address1: '',
    address2: '',
    address3: '',
    name: '',
    address2_hidden: false,
    is_facility_resident: true,
    address3_check: false,
    is_special_area_addition: false,
    is_default: false,
    ...defaultValues,
  };
}
